module.exports = __webpack_public_path__ + "static/media/tinyPhone.1799c8a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tinyPhone.svg
// module id = 508
// module chunks = 0